import VolumeFigureInputForm from './VolumeFigureInputForm'
import VolumeFigurePreview from './VolumeFigurePreview'

/**
 * Router component to show correct step input form for Volume Figure Generator
 * Maps step number to appropriate component
 */
const STEP_COMPONENTS = {
  1: VolumeFigureInputForm, // Step 1: Enter volume data
  3: VolumeFigurePreview, // Step 3: Preview and review
}

/**
 * Step Input Router for Volume Figure Generator workflow
 * @param {Object} analysis - Full analysis object
 * @param {Object} step - Current step object
 * @param {Function} onSubmit - Submit callback
 * @param {boolean} loading - Loading state
 */
function StepInputRouter({ analysis, step, onSubmit, loading = false }) {
  const Component = STEP_COMPONENTS[step.step_number]

  if (!Component) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <p className="text-sm text-yellow-800">
          No input form configured for step {step.step_number}.
        </p>
      </div>
    )
  }

  return <Component analysis={analysis} step={step} onSubmit={onSubmit} loading={loading} />
}

export default StepInputRouter
